import { ThemeContext } from "contexts";
import React from "react";

type LoadingProps = {
  small?: boolean;
  style?: React.CSSProperties;
};

const Loading: React.FC<LoadingProps> = ({ style, small = false }) => {
  const theme = React.useContext(ThemeContext);

  return (
    <div
      style={{
        ...styles.loader,
        ...(small ? styles.loaderSmall : {}),
        borderTop: `5px solid ${theme?.themeColor ?? "#00B7F4"}`,
        ...style,
      }}
    />
  );
};

const styles = {
  loader: {
    border: "5px solid #f3f3f3",
    borderTop: "5px solid #00B7F4",
    borderRadius: "50%",
    width: "35px",
    height: "35px",
    animation: "spin 1s linear infinite",
    margin: "0 auto",
  },
  loaderSmall: {
    width: "15px",
    height: "15px",
  },
} as const;

export default Loading;
